import ShiftCompletionSummaryDto from "@/models/Shifts/ShiftCompletionSummaryDto";
import BookingRoleWeekDto from "@/models/BookingRoles/BookingRoleWeekDto";

export default class BookingRoleWeekStatisticsDto {
    dates: number[] = [];
    bookingRoleWeeks: BookingRoleWeekDto[] = [];
    totalShifts = 0
    totalHours = 0
    totalCharge = 0
    totalPay = 0
    totalGp = 0
    bookedShifts = 0
    bookedConfirmedShifts = 0;
    bookedUnconfirmedShifts = 0;
    bookedHours = 0
    bookedCharge = 0
    bookedPay = 0
    bookedGp = 0
    remainingShifts = 0
    remainingHours = 0
    remainingCharge = 0
    remainingPay = 0
    remainingGp = 0
    monday: ShiftCompletionSummaryDto = new ShiftCompletionSummaryDto();
    tuesday: ShiftCompletionSummaryDto = new ShiftCompletionSummaryDto();
    wednesday: ShiftCompletionSummaryDto = new ShiftCompletionSummaryDto();
    thursday: ShiftCompletionSummaryDto = new ShiftCompletionSummaryDto();
    friday: ShiftCompletionSummaryDto = new ShiftCompletionSummaryDto();
    saturday: ShiftCompletionSummaryDto = new ShiftCompletionSummaryDto();
    sunday: ShiftCompletionSummaryDto = new ShiftCompletionSummaryDto();
}